import { render } from "./homeworkHome.vue?vue&type=template&id=d1cb39c4&scoped=true"
import script from "./homeworkHome.vue?vue&type=script&lang=js"
export * from "./homeworkHome.vue?vue&type=script&lang=js"

import "./homeworkHome.vue?vue&type=style&index=0&id=d1cb39c4&lang=scss&scoped=true"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1cb39c4"]])

export default __exports__